import home from '../page/home/home'
import authorize from '../page/home/authorize'
import authorizeEfz from '../page/home/authorize-efz'
import clear from '../page/home/clear'
import home1 from '../page/home/home1'
import homes from '../page/home/home-s'
import homeZj from '../page/home/home-zj'
import homeSearch from '../page/home-search/home-search'
import station from '../page/station/station'
import city from '../page/city/city'
import cityCard from '../page/city-card/city-card'

import viewList from '../page/view-list/view-list'
import viewFree from '../page/view-list/view-free'
import viewDetail from '../page/view-detail/view-detail'
import viewDetailLz from '../page/view-detail/view-detail-lz'
import viewDetailSm from '../page/view-detail/view-detail-sm'
import viewDetailNx from '../page/view-detail/view-detail-nx'
import viewDetailGroup from '../page/view-detail/view-detail-group.vue'
import viewDetailJc2 from '../page/view-detail/view-detail-jc2'
import waterfallLz from '../page/view-detail/waterfall-lz'
import spotDetail from '../page/spot-detail/spot-detail'
import spotDetailSm from '../page/spot-detail/spot-detail-sm'
import spotDetailNx from '../page/spot-detail/spot-detail-nx'
import map from '../page/map/map'
import mapVR from '../page/map/map-vr'
import mapTour from '../page/map/map-tour'
import mapDesc from '../page/map/map-desc'
import mapComment from '../page/map/map-comment'
import mapBus from '../page/map/map-bus'

import voiceList from '../page/voice-list/voice-list'
import videoPlay from '../page/video-play/video-play'
import videoDown from '../page/video-play/video-down'
import videoPlayLz from '../page/video-play/video-play-lz'
import videoPlayLz1 from '../page/video-play/video-play-lz1'
import videoPlayVr from '../page/video-play/video-play-vr'
import videoPlaySm from '../page/video-play/video-play-sm'
import videoPlayNx from '../page/video-play/video-play-nx'
import videoPlayPy from '../page/video-play/video-play-py'
import videoPlay1 from '../page/video-play1/video-play1'
import videoVR from '../page/video-vr/video-vr'
import videoVRlink from '../page/video-vr/video-vrlink'
import videoVRlist from '../page/video-vrlist/video-vrlist'
import videoVRlistNew from '../page/video-vrlist/video-vrlist-new'
import videoVRlistxj from '../page/video-vrlist/video-vrlist-xj'
import videolistcd from '../page/video-vrlist/video-list-cd'
import videolistcdDesc from '../page/video-vrlist/video-list-cd-detail'
import guideInfo from '../page/guide-info/guide-info'
import comment from '../page/comment/comment'

import videoList from '../page/view-detail/video-list'
import videoWatch from '../page/view-detail/video-watch'

import pay from '../page/pay/pay'
import payPy from '../page/pay/pay-py'
import payJhm from '../page/pay/pay-jhm'

import user from '../page/user/user'
import myComment from '../page/my-comment/my-comment'
import purchase from '../page/purchase/purchase'
import listenHistory from '../page/listen-history/listen-history'
import couponList from '../page/coupon-list/coupon-list'
import agreement from '../page/agreement/agreement'

import extendIndex from '../page/extend-index/extend-index'
import extendLogin from '../page/extend-login/extend-login'
import extendArticle from '../page/extend-article/extend-article'
import extendCenter from '../page/extend-center/extend-center'
import extendAccount from '../page/extend-account/extend-account'

import studyActivity from '../page/study-activity/study-activity'
import studyActivityGZ from '../page/study-activity-gz/study-activity-gz'
import studyActivityGZ01 from '../page/study-activity-gz/study-activity-01'
import studyActivityGZ02 from '../page/study-activity-gz/study-activity-02'
import study from '../page/study/study'
import studyDetail from '../page/study-detail/study-detail'

import waterFall from '../page/waterfall/waterfall'
import downloadList from '../page/download-list/download-list'

import citySite from '../page/city-site/city-site'
import citySiteMuseum from '../page/city-site/city-museum-list'
import citySiteHistory from '../page/city-site/city-history-list'
import citySiteFood from '../page/city-site/city-food-list'
import citySiteStrategy from '../page/city-site/city-strategy-list'
import citySiteStrategyDetail from '../page/city-site/city-strategy-detail'
import citySiteArticle from '../page/city-site/city-article'
import citySiteView from '../page/city-site/city-view-list'

import storyDetail from '../page/story/story-detail'
import storyDetailS from '../page/story/story-detail-s'

import h5Map from '../page/h5/dh-map'
import zhongqiu from '../page/h5/zhongqiu'

import videoPlayPt from '../page/video-vr/video-play.vue' // 普通视频播放

/*AR激活码激活*/
import arActive from '../page/ar/ar-active.vue'
import arListTy from '../page/ar/ar-list-ty.vue'
import arListJh from '../page/ar/ar-list-jh.vue'

/* 系统维护中 */
import system from '../page/400/400'
/* 用户授权 */
import system1 from '../page/400/401'
/* 404必须是最后一个路由 */
import notFound from '../page/404/404'

export default [
  {
    path: '/',
    meta: {
      keepAlive: false,
      title: '金牌解说'
    },
    component: home
  },
  {
    path: '/authorize',
    meta: {
      keepAlive: false,
      title: '授权'
    },
    component: authorize
  },
  {
    path: '/authorize-efz',
    meta: {
      keepAlive: false,
      title: '授权'
    },
    component: authorizeEfz
  },
  {
    path: '/clear',
    meta: {
      keepAlive: false,
      title: '/清除缓存'
    },
    component: clear
  },
  {
    path: '/home-s',
    meta: {
      keepAlive: false,
      title: '黄河流域'
    },
    component: homes
  },
  {
    path: '/home1',
    meta: {
      keepAlive: false,
      title: '金牌解说'
    },
    component: home1
  },
  {
    path: '/home-zj',
    meta: {
      keepAlive: false,
      title: '金牌解说'
    },
    component: homeZj
  },
  {
    path: '/home-search',
    meta: {
      keepAlive: false,
      title: '搜索结果'
    },
    component: homeSearch
  },
  {
    path: '/station',
    meta: {
      keepAlive: false,
      title: '金牌解说'
    },
    component: station
  },
  {
    path: '/city',
    meta: {
      keepAlive: false,
      title: '城市选择'
    },
    component: city
  },
  {
    path: '/city-card',
    meta: {
      keepAlive: false,
      title: '城市名片'
    },
    component: cityCard
  },
  {
    path: '/view-list',
    meta: {
      keepAlive: false,
      title: '所有景区'
    },
    component: viewList
  },
  {
    path: '/view-free',
    meta: {
      keepAlive: false,
      title: '免费景区'
    },
    component: viewFree
  },
  {
    path: '/view-detail',
    meta: {
      keepAlive: false,
      title: '景区详情'
    },
    component: viewDetail
  },
  {
    path: '/view-detail-lz',
    meta: {
      keepAlive: false,
      title: '景区详情'
    },
    component: viewDetailLz
  },
  {
    path: '/view-detail-group',
    meta: {
      keepAlive: false,
      title: '景区解说包'
    },
    component: viewDetailGroup
  },
  {
    path: '/view-detail-jc2',
    meta: {
      keepAlive: false,
      title: '子景区详情'
    },
    component: viewDetailJc2
  },
  {
    path: '/waterfall-lz',
    meta: {
      keepAlive: true,
      title: '所有图片'
    },
    component: waterfallLz
  },
  {
    path: '/view-detail-sm',
    meta: {
      keepAlive: false,
      title: '景区详情'
    },
    component: viewDetailSm
  },
  {
    path: '/view-detail-nx',
    meta: {
      keepAlive: false,
      title: '景区详情'
    },
    component: viewDetailNx
  },
  {
    path: '/spot-detail',
    meta: {
      keepAlive: false,
      title: '景点详情'
    },
    component: spotDetail
  },
  {
    path: '/spot-detail-sm',
    meta: {
      keepAlive: false,
      title: '景点详情'
    },
    component: spotDetailSm
  },
  {
    path: '/spot-detail-nx',
    meta: {
      keepAlive: false,
      title: '景点详情'
    },
    component: spotDetailNx
  },
  {
    path: '/map',
    meta: {
      keepAlive: false,
      title: '地图导览'
    },
    component: map
  },
  {
    path: '/map-vr',
    meta: {
      keepAlive: false,
      title: '地图导览'
    },
    component: mapVR
  },
  {
    path: '/map-tour',
    meta: {
      keepAlive: true,
      title: '地图导览'
    },
    component: mapTour
  },
  {
    path: '/map-desc',
    meta: {
      keepAlive: false,
      title: '地图导览'
    },
    component: mapDesc
  },
  {
    path: '/map-comment',
    meta: {
      keepAlive: false,
      title: '地图导览'
    },
    component: mapComment
  },
  {
    path: '/map-bus',
    meta: {
      keepAlive: false,
      title: '班车时刻表'
    },
    component: mapBus
  },
  {
    path: '/voice-list',
    meta: {
      keepAlive: false,
      title: '所有解说'
    },
    component: voiceList
  },
  {
    path: '/video-play',
    meta: {
      keepAlive: false,
      title: '专辑详情'
    },
    component: videoPlay
  },
  {
    path: '/video-down',
    meta: {
      keepAlive: false,
      title: '专辑详情'
    },
    component: videoDown
  },
  {
    path: '/video-play-lz',
    meta: {
      keepAlive: false,
      title: '专辑详情'
    },
    component: videoPlayLz
  },
  {
    path: '/video-play-lz1',
    meta: {
      keepAlive: false,
      title: '语音解说'
    },
    component: videoPlayLz1
  },
  {
    path: '/video-play-vr',
    meta: {
      keepAlive: false,
      title: '语音解说'
    },
    component: videoPlayVr
  },
  {
    path: '/video-play-sm',
    meta: {
      keepAlive: false,
      title: '专辑详情'
    },
    component: videoPlaySm
  },
  {
    path: '/video-play-nx',
    meta: {
      keepAlive: false,
      title: '专辑详情'
    },
    component: videoPlayNx
  },
  {
    path: '/video-play-py',
    meta: {
      keepAlive: false,
      title: '专辑详情'
    },
    component: videoPlayPy
  },
  {
    path: '/video-play1',
    meta: {
      keepAlive: false,
      title: '景区视频'
    },
    component: videoPlay1
  },
  {
    path: '/video-vr',
    meta: {
      keepAlive: false,
      title: '视频讲解'
    },
    component: videoVR
  },

  {
    path: '/video-play-pt',
    meta: {
      keepAlive: false,
      title: '视频讲解'
    },
    component: videoPlayPt
  },
  {
    path: '/video-vrlink',
    meta: {
      keepAlive: false,
      title: '视频讲解'
    },
    component: videoVRlink
  },
  {
    path: '/video-vrlist',
    meta: {
      keepAlive: false,
      title: '视频讲解'
    },
    component: videoVRlist
  },
  {
    path: '/video-vrlist-new',
    meta: {
      keepAlive: true,
      title: '视频讲解'
    },
    component: videoVRlistNew
  },
  {
    path: '/video-vrlist-xj',
    meta: {
      keepAlive: false,
      title: ''
    },
    component: videoVRlistxj
  },
  {
    path: '/video-list-cd',
    meta: {
      keepAlive: true,
      title: ''
    },
    component: videolistcd
  },
  {
    path: '/video-list-cd-detail',
    meta: {
      keepAlive: false,
      title: ''
    },
    component: videolistcdDesc
  },
  {
    path: '/guide-info',
    meta: {
      keepAlive: false,
      title: '导游简介'
    },
    component: guideInfo
  },
  {
    path: '/pay',
    meta: {
      keepAlive: false,
      title: '支付'
    },
    component: pay
  },
  {
    path: '/pay-py',
    meta: {
      keepAlive: false,
      title: '支付'
    },
    component: payPy
  },
  {
    path: '/pay-jhm',
    meta: {
      keepAlive: false,
      title: '激活码'
    },
    component: payJhm
  },
  {
    path: '/user',
    meta: {
      keepAlive: false,
      title: '我的'
    },
    component: user
  },
  {
    path: '/my-comment',
    meta: {
      keepAlive: false,
      title: '我的评论'
    },
    component: myComment
  },
  {
    path: '/purchase',
    meta: {
      keepAlive: false,
      title: '我的已购'
    },
    component: purchase
  },
  {
    path: '/coupon-list',
    meta: {
      keepAlive: false,
      title: '我的优惠券'
    },
    component: couponList
  },
  {
    path: '/listen-history',
    meta: {
      keepAlive: false,
      title: '收听历史'
    },
    component: listenHistory
  },
  {
    path: '/agreement',
    meta: {
      keepAlive: false,
      title: '用户协议'
    },
    component: agreement
  },
  {
    path: '/comment',
    meta: {
      keepAlive: false,
      title: '评论'
    },
    component: comment
  },
  {
    path: '/extend-index',
    meta: {
      keepAlive: false,
      title: '推广介绍'
    },
    component: extendIndex
  },
  {
    path: '/extend-login',
    meta: {
      keepAlive: false,
      title: '推广'
    },
    component: extendLogin
  },
  {
    path: '/extend-article',
    meta: {
      keepAlive: false,
      title: '邀请码须知'
    },
    component: extendArticle
  },
  {
    path: '/extend-center',
    meta: {
      keepAlive: false,
      title: '推广提现'
    },
    component: extendCenter
  },
  {
    path: '/extend-account',
    meta: {
      keepAlive: false,
      title: '提现中心'
    },
    component: extendAccount
  },
  {
    path: '/study-activity',
    meta: {
      keepAlive: false,
      title: '研学活动'
    },
    component: studyActivity
  },
  {
    path: '/study-activity-gz',
    meta: {
      keepAlive: false,
      title: '研学活动'
    },
    component: studyActivityGZ
  },
  {
    path: '/study-activity-01',
    meta: {
      keepAlive: false,
      title: '研学活动'
    },
    component: studyActivityGZ01
  },
  {
    path: '/study-activity-02',
    meta: {
      keepAlive: false,
      title: '研学活动'
    },
    component: studyActivityGZ02
  },
  {
    path: '/study',
    meta: {
      keepAlive: false,
      title: '研学系统'
    },
    component: study
  },
  {
    path: '/study-detail',
    meta: {
      keepAlive: false,
      title: '研学景点路线'
    },
    component: studyDetail
  },
  {
    path: '/waterfall',
    meta: {
      keepAlive: true,
      title: '更多导游'
    },
    component: waterFall
  },
  {
    path: '/download-list',
    meta: {
      keepAlive: false,
      title: '离线列表'
    },
    component: downloadList
  },
  {
    path: '/city-site',
    meta: {
      keepAlive: true,
      title: '城市站点'
    },
    component: citySite
  },
  {
    path: '/city-museum-list',
    meta: {
      keepAlive: false,
      title: '数字文博云讲解'
    },
    component: citySiteMuseum
  },
  {
    path: '/city-history-list',
    meta: {
      keepAlive: false,
      title: '讲人文听历史'
    },
    component: citySiteHistory
  },
  {
    path: '/city-food-list',
    meta: {
      keepAlive: false,
      title: '说美食列表'
    },
    component: citySiteFood
  },
  {
    path: '/city-strategy-list',
    meta: {
      keepAlive: false,
      title: '攻略推荐'
    },
    component: citySiteStrategy
  },
  {
    path: '/city-strategy-detail',
    meta: {
      keepAlive: false,
      title: '攻略推荐详情'
    },
    component: citySiteStrategyDetail
  },
  {
    path: '/city-article',
    meta: {
      keepAlive: false,
      title: '推文'
    },
    component: citySiteArticle
  },
  {
    path: '/city-view-list',
    meta: {
      keepAlive: false,
      title: '景区列表'
    },
    component: citySiteView
  },
  {
    path: '/video-list',
    meta: {
      keepAlive: false,
      title: '视频专辑'
    },
    component: videoList
  },
  {
    path: '/story-detail',
    meta: {
      keepAlive: false,
      title: '太史图'
    },
    component: storyDetail
  },
  {
    path: '/dh-map',
    meta: {
      keepAlive: true,
      title: '导览图'
    },
    component: h5Map
  },
  {
    path: '/zhongqiu',
    meta: {
      keepAlive: false,
      title: '“VR云游中国 有声旅游护照”线上旅游活动'
    },
    component: zhongqiu
  },
  {
    path: '/story-detail-s',
    meta: {
      keepAlive: false,
      title: '太史图'
    },
    component: storyDetailS
  },
  {
    path: '/ar-active',
    meta: {
      keepAlive: false,
      title: 'AR体验激活'
    },
    component: arActive
  },
  {
    path: '/ar-list-ty',
    meta: {
      keepAlive: false,
      title: 'AR互动体验'
    },
    component: arListTy
  },
  {
    path: '/ar-list-jh',
    meta: {
      keepAlive: false,
      title: '已激活专辑'
    },
    component: arListJh
  },
  {
    path: '/401',
    meta: {
      keepAlive: false,
      title: '用户授权'
    },
    component: system1
  },
  {
    path: '/400',
    meta: {
      keepAlive: false,
      title: '系统维护中'
    },
    component: system
  },
  { /* 404必须是最后一个路由 */
    path: '*',
    meta: {
      keepAlive: false,
      title: '找不到页面'
    },
    component: notFound
  }

]



// WEBPACK FOOTER //
// ./src/router/index.js